import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import type { HcpSearchRow, HcoSearchRow, ExUsSearchRow } from '../types/api/generated';
import { HcpSearchRowSchema, HcoSearchRowSchema, ExUsSearchRowSchema } from '../types/api/schemas';
import { validateResponse } from './validateResponse';

export const searchApi = createApi({
    reducerPath: 'searchApi',
    baseQuery,
    endpoints: (builder) => ({
        searchHcp: builder.mutation<HcpSearchRow[], unknown>({
            query: (body) => ({ url: 'api/v2/search/hcp', method: 'POST', body }),
            transformResponse: validateResponse(HcpSearchRowSchema.array()),
        }),
        searchHco: builder.mutation<HcoSearchRow[], unknown>({
            query: (body) => ({ url: 'api/v2/search/hco', method: 'POST', body }),
            transformResponse: validateResponse(HcoSearchRowSchema.array()),
        }),
        searchExUs: builder.mutation<ExUsSearchRow[], unknown>({
            query: (body) => ({ url: 'api/v2/search/exus', method: 'POST', body }),
            transformResponse: validateResponse(ExUsSearchRowSchema.array()),
        }),
    }),
});

export const {
    useSearchHcpMutation,
    useSearchHcoMutation,
    useSearchExUsMutation,
} = searchApi;
